/* Rquiere de mixin.js */

var priceList = {
	data () {
		return {
			listPriceLists: [],
			methods: {
				priceListGet: 'priceLists',
			},
			paginationPriceLists: [],
			searchPriceLists: '',
			priceListIdSelected: 0,
			searchingPriceList: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllPriceLists(page = 1) {
			this.searchingPriceList = true
			let parameters = '?search=' + this.searchPriceLists + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methods.priceListGet + parameters, 'GET', 'getAllPriceListsResult')
        },
        getAllPriceListsResult(response) {
			this.searchingPriceList = false
            this.listPriceLists = response.data.data
            this.getAllPriceListsResultLocal(response)
        },
        getAllPriceListsResultLocal(response) {
            console.log('getAllPriceListsResultLocal no desarrollado', response)
        }
	},
};

export default priceList;